module.exports = __webpack_public_path__ + "/images/logo-app-appstore.en-GB.1cfd5db.svg";